// apenas números nos campos
function onlyNumbers(e, setFieldValue, fieldName) {
  const { value } = e.target;

  // 1. Substituição de vírgula
  if (e.key === ',') {
    e.preventDefault();
    const currentValue = e.target.value;
    setFieldValue(fieldName, currentValue + '.');
    return;
  }



  // 2. Controle de colagem (Ctrl+V)
  if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
    // Temporariamente permitir colagem para tratamento assíncrono
    setTimeout(() => {
      const pastedValue = e.target.value;
      // Sanitiza o valor colado
      const sanitized = pastedValue
        .replace(/[^\d,.]/g, '') // Remove caracteres não numéricos
        .replace(/,/g, '.')      // Substitui vírgulas por pontos
        .replace(/(\.\d{2}).*$/, '$1'); // Limita a 2 casas decimais

      // Aplica validações
      const [integerPart, decimalPart] = sanitized.split('.');
      let finalValue = sanitized;

      // Limita parte inteira a 3 dígitos
      if (integerPart.length > 3) {
        finalValue = integerPart.slice(0, 3) + (decimalPart ? `.${decimalPart}` : '');
      }

      // Limita valor máximo a 500
      if (Number(finalValue) > 500) {
        finalValue = '500';
      }

      setFieldValue(fieldName, finalValue);
    }, 0);
    return;
  }

  // 3. Teclas permitidas
  const allowedKeys = [
    'Tab', 'Backspace', 'Delete',
    'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
    'Home', 'End'
  ];

  if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey || e.altKey) {
    return;
  }

  // 4. Validação de caracteres
  if (!/[0-9.]/.test(e.key)) {
    e.preventDefault();
    return;
  }

  // 5. Prevenção de múltiplos pontos
  if (e.key === '.' && (value.includes('.') || value === '')) {
    e.preventDefault();
    return;
  }

  // 6. Simulação do novo valor
  const newValue = value + e.key;
  const [integerPart, decimalPart] = newValue.split('.');

  // 7. Validações finais
  if (integerPart.length > 3 && e.key !== 'Backspace' && e.key !== 'Delete') {
    e.preventDefault();
    return;
  }

  if (Number(newValue) > 500) {
    e.preventDefault();
    return;
  }

  if (decimalPart && decimalPart.length > 2) {
    e.preventDefault();
    return;
  }
}
//
function handleNumberInput(e, setFieldValue, fieldName) {
  const { value } = e.target;

  // 1. Substituição de vírgula por ponto
  if (e.key === ',') {
    e.preventDefault();
    const newValue = value + '.'; // Adiciona o ponto no final
    setFieldValue(fieldName, newValue);
    return;
  }

  // 2. Validação de teclas permitidas
  const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'];
  if (allowedKeys.includes(e.key)) {
    return;
  }

  // 3. Validação de caracteres
  if (!/[0-9.]/.test(e.key)) {
    e.preventDefault();
    return;
  }

  // 4. Validação de formato
  const newValue = value + e.key;
  if (!isValidNumber(newValue, 3, 2, 500)) {
    e.preventDefault();
  }
}

function isValidNumber(value, maxInteger, maxDecimal, maxValue) {
  if (value === '') return true;
  if (value === '.') return false;

  const num = Number(value);
  if (isNaN(num)) return false;

  const parts = value.split('.');
  if (parts[0].length > maxInteger) return false;
  if (parts[1] && parts[1].length > maxDecimal) return false;
  if (num > maxValue) return false;

  return true;
}
// não permitir envio do form ao pressionar enter
function handleKeyDown(e) {
  if (e.key === 'Enter') {
    e.preventDefault();
  }
}

// Função para converter data DD/MM/YYYY para YYYY-MM-DD
function convertDateForDatabase(formattedDate) {
  if (!formattedDate) return null; // Retorna null se a data for inválida ou não fornecida
  // Verifica se a string está no formato esperado
  const [day, month, year] = formattedDate.trim().split('/');
  if (!day || !month || !year) return null;
  // Retorna a data formatada para o banco
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

function formatGroup(selectedPatientGroup) {
  switch (selectedPatientGroup) {
    case '1':
      return 'Lactente';
    case '2':
      return 'Criança';
    case '3':
      return 'Adulto';
    case '4':
      return 'Idoso';
    case '5':
      return 'Gestante';
    case '6':
      return 'Lactante';
    default:
      return '';

  }
}

function formatedClassificatoinBlackburn(classifyBlackburn) {
  switch (classifyBlackburn) {
    case 'Normal':
      return 'Normal';
    case 'Mild depletion':
      return 'Depleção leve';
    case 'Moderate depletion':
      return 'Depleção moderada';
    case 'Severe depletion':
      return 'Depleção severa';
    default:
      return '';

  }
}

function formatedClassificationBMI(classification) {
  switch (classification) {
    case 'Severe Thinness Grade III':
      return 'Magreza severa grau III';
    case 'Thinness Grade II':
      return 'Magreza severa grau II';
    case 'Thinness Grade I':
      return 'Magreza severa grau I';
    case 'Normal':
      return 'Normal';
    case 'Overweight':
      return 'Sobrepeso';
    case 'Obesity Grade I':
      return 'Obesidade grau I';
    case 'Obesity Grade II':
      return 'Obesidade grau II';
    case 'Obesity Grade III':
      return 'Obesidade grau III';
    case 'z-Score not provided':
      return 'z-Score não informado';
    default:
      return classification;
  }
}

function formatedClassificationChildBMI(classification) {
  switch (classification) {
    case 'Overweight':
      return 'Sobrepeso';
    case 'Adequate weight':
      return 'Peso adequado';
    case 'Underweight':
      return 'Baixo peso';
    case 'Undetermined':
      return 'Indeterminado';
    default:
      return classification;
  }
}

function formatedClassificationElderlyBMI(classification) {
  switch (classification) {
    case 'Underweight':
      return 'Baixo peso';
    case 'Normal':
      return 'Normal';
    case 'Overweight':
      return 'Sobrepeso';
    case 'Undetermined':
      return 'Indeterminado';
    default:
      return classification;
  }
}

function formatedClassificationBiotype(classification) {
  switch (classification) {
    case 'Short-limbed':
      return 'Brevilíneo';
    case 'Normal-limbed':
      return 'Mesolíneo';
    case 'Long-limbed':
      return 'Longilíneo';
    case 'Undetermined':
      return 'Indeterminado';
    default:
      return classification;
  }
}

function formatedClassificationWaist(classification) {
  switch (classification) {
    case 'No risk':
      return 'Sem risco';
    case 'Increased risk':
      return 'Risco aumentado';
    case 'High risk':
      return 'Alto risco';
    case 'Undetermined':
      return 'Indeterminado';
    default:
      return classification;
  }
}

function formatedClassificationInternalFat(classification) {
  switch (classification) {
    case 'High':
      return 'Alta';
    case 'Normal':
      return 'Normal';
    default:
      return classification;
  }
}

function formatedDiagnosisMuscle(classification) {
  switch (classification) {
    case 'Obesity':
      return 'Obesidade';
    case 'Excess fat':
      return 'Excesso de gordura';
    case 'Low muscle mass':
      return 'Baixa massa muscular';
    case 'Normal':
      return 'Normal';
    default:
      return classification;
  }
}

function formatedClassificationBray(classifyBray) {
  switch (classifyBray) {
    case 'Severe Thinness Grade III':
      return 'Magreza severa grau III';
    case 'severe Thinness Grade II':
      return 'Magreza severa grau II';
    case 'Severe Thinness Grade I':
      return 'Magreza severa grau I';
    case 'Normal':
      return 'Normal';
    case 'Overweight':
      return 'Sobrepeso';
    case 'Obesity Grade I':
      return 'Obesidade grau I';
    case 'Obesity Grade II':
      return 'Obesidade grau II';
    case 'Obesity Grade III':
      return 'Obesidade grau III';
    default:
      return '';

  }
}

function formatedClassificationMuscleMass(classification) {
  switch (classification) {
    case 'Low muscle mass':
      return 'Baixa massa muscular';
    case 'Below average':
      return 'Abaixo da média';
    case 'Average':
      return 'Média';
    case 'Above average':
      return 'Acima da média';
    case 'High muscle mass':
      return 'Alta massa muscular';
    case 'Undetermined':
      return 'Indeterminado';
    default:
      return classification;
  }
}

function formatedClassificationLeanMass(classification) {
  switch (classification) {
    case 'Low':
      return 'Baixa';
    case 'Normal':
      return 'Normal';
    default:
      return classification;
  }
}

function formatedClassificationBernadinelli(classification) {
  switch (classification) {
    case 'Long-limbed':
      return 'Longilíneo';
    case 'Normal':
      return 'Mesolíneo';
    case 'Short-limbed':
      return 'Brevilíneo';
    default:
      return classification;
  }
}

function formatedClassificationLeanWeightType(classification) {
  switch (classification) {
    case 'Low':
      return 'Baixa';
    case 'Normal':
      return 'Normal';
    case 'Undefined':
      return 'Não definida';
    default:
      return classification;
  }
}
function formatedClassificationWaistCircumference(classification) {
  switch (classification) {
    case 'No risk':
      return 'Sem risco';
    case 'Increased risk':
      return 'Risco aumentado';
    case 'High risk':
      return 'Alto risco';
    case 'Undetermined':
      return 'Indeterminado';
    default:
      return classification;
  }
}


module.exports = {
  onlyNumbers,
  handleKeyDown,
  convertDateForDatabase,
  formatGroup,
  formatedClassificatoinBlackburn,
  formatedClassificationBMI,
  formatedClassificationBray,
  formatedClassificationBernadinelli,
  formatedClassificationChildBMI,
  formatedClassificationElderlyBMI,
  formatedClassificationBiotype,
  formatedClassificationWaist,
  formatedClassificationInternalFat,
  formatedDiagnosisMuscle,
  formatedClassificationMuscleMass,
  formatedClassificationLeanMass,
  formatedClassificationLeanWeightType,
  formatedClassificationWaistCircumference,
  handleNumberInput
}